import { config } from "../../../../../config";
import yup from "../../../../../utils/yup";

import type { LinkType } from "../button/types";

const urlSchema = yup
  .string()
  .test("is-url-or-merge-tag", (value, { createError }) => {
    if (!value || !["https://", "http://", "mailto:"].find((x) => value.startsWith(x))) {
      return createError({
        message: "Enter a link in a valid format, including https:// or mailto:",
      });
    }

    if (value.startsWith("mailto:")) {
      const validEmail = yup.string().email().required().isValidSync(value.replace("mailto:", ""));
      return validEmail || createError({ message: "Enter an email address in a valid format" });
    }

    const validLink = yup
      .string()
      .url_or_merge_tag("Enter a link in a valid format")
      .isValidSync(value);
    return validLink || createError({ message: "Enter a link in a valid format" });
  })
  .required("Enter a URL for the link")
  .default("");

const textSchema = yup
  .string()
  .required("Enter some text for the link")
  .default("")
  .max(config.slack.maxBlockLength, "Link text too long.");

export interface Link {
  url: string;
  text?: string;
  type?: LinkType["type"];
}

export const rangeAddSchema = yup.object({
  text: textSchema,
  url: urlSchema,
});

export const defaultSchema = yup.object({
  text: yup.string(),
  url: urlSchema,
});
